import React from "react";
import "./t&c.css";

export default function TermsConditions() {
  return (
    <>
      <div class="section_tc">
        <div class="container_tc">
          <div class="content-section_tc">
            <div class="image-section_tc"></div>
            <div class="title_tc">
              <h1>Terms and Conditions</h1>
            </div>
            <div class="content_tc">
              <h3>AGREEMENT BETWEEN WEBSITE USER AND FODRIX PRIVATE LTD.</h3>
              <p>
                {" "}
                @Copyright Fodrix Private Lid. 2021. All rights reserved. All
                the text, images, graphics, design, content, and other works are
                the copyrighted works of Fodrix Private Ltd.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>TERMS AND CONDITIONS OF USE</h3>
              <p>
                {" "}
                © Copyright Fodrix Private Ltd. (“Fodrix”) 2021. All rights
                reserved. All the photographs, design, content, and other works
                are the copyrighted works of Fodrix. Welcome to the website of
                Fodrix, www.fodrix.com. Use of this website is governed by the
                Terms and Conditions set forth. Please read these Terms and
                Conditions carefully before using this website. The information
                and materials provided by Fodrix may be used for informational
                purposes only. Using, accessing, or downloading materials from
                this website means you agreeing all the terms and provisions as
                given here, which apply to all visits to the Fodrix website.
                Fodrix can make any type of update in terms and conditions at
                any time. In the following terms & conditions, the “Company”
                shall mean Fodrix. This agreement is by and between “Company”
                and “Client” which includes the Clients, employees, and
                representatives. These Terms & Conditions cannot be varied in
                any way by the Clients unless such conditions are expressly
                agreed upon by the photographer in writing.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>1. DISPLAY</h3>
              <p>
                1.1 The client(s) hereby allows the Company to display any
                photograph covered by this contract and to generally promote the
                business in advertising, social media, brochures, magazine
                articles, websites, sample albums, etc.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>2. Creative license, coverage, and reproduction</h3>
              <p>
                2.1 - Photographs taken during the course of the event will be
                at the discretion of the photographer although every effort will
                be made to comply with the client’s requirements.
              </p>
              <p>
                2.2 - Special requests are not binding instruction, although
                every effort is made to comply with the Client’s wishes. The
                Photographer(s) will do their best to honor the requested
                photographs but do not undertake to guarantee any specific
                picture nor incorporate any specific background, location, or
                group arrangements due to changes in weather and the
                availability and willingness of subjects.
              </p>
              <p>
                2.3 - Due to a variety of lighting conditions and the
                limitations of digital sensors, some colors may alter throughout
                a set of photographs.
              </p>
              <p>
                2.4 - Although all equipment is checked regularly and reasonable
                steps are taken to ensure backup equipment is available, the
                company or the photographer will not be responsible for
                photographs that are not produced due to technical failure.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>3. PAYMENTS</h3>
              <p>Client(s) agrees to pay the charge on the day of paymenT</p>
              <p>
                3.1 - One time complete payment: The payment module will be a
                full 100% amount (all the payments will be government from the
                Terms and Conditions at the time of booking) at the time of
                booking.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>4. MODE OF PAYMENT</h3>
              <p>
                Clients agree to pay the payment from an online medium. Payment
                will not be accepted by any other mode.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>5. EXPENSES</h3>
              <p>
                5.1 - Where extra expenses or times are incurred by the
                Photographer as a result of alterations to the original brief by
                the Client(s), or otherwise, the Client shall give approval to
                and be liable to such extra expenses or fees, in addition to the
                fees and expenses shown on the Estimate as having been agreed or
                estimated.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>6. FAILURE TO PERFORM</h3>
              <p>
                6.1 - If Photographer is unable to supply his photographic
                services due to illness, mechanical breakdown, accident, the act
                of God, or any other cause beyond his control, then Photographer
                will attempt to procure the services of another professional
                photographer to fulfill his obligations. If that does not
                succeed, the Company will return any fees paid by Client and
                will have no further liability with respect to this agreement,
                and Photographer will not be responsible or liable for any other
                damages beyond the amount of this agreement.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>7. DELIVERABLES</h3>
              <p>7.1 - Processed pictures or edited pictures</p>
              <p>
                7.1.1 - After receiving processed pictures, the client needs to
                inform of any pictures’ re-editing or extra pictures editing
                requirement within 3 days from the date of receiving processed
                pictures.
              </p>
              <p>
                7.1.2 - Extra basic charges will be applicable in case any
                pictures’ re-editing or extra pictures editing requirement is
                shared after 3 days of the time period.
              </p>
              <p>
                7.1.3 - Charges will be applicable as per rework requirement and
                projects’ scale.
              </p>
              <p>
                7.1.4 - We are providing only a one-time rework facility in
                photo processing. Hence re-editing or extra pictures editing
                requirements to be shared completely at once only.
              </p>
              <p>
                7.1.5 - Further deliveries will be delayed in case of a delayed
                response from the client.
              </p>
              <p>
                7.1.6 - Once the final delivery is confirmed and completed, no
                extra requirements will be served without payment.
              </p>
              <p>7.2 - Cinematic film:</p>
              <p>
                7.2.1 - Client needs to provide feedback on the list of songs
                shared through mail or his/her choice of songs within 24 hrs of
                receiving the song list else we will be proceeding with the same
                songs in a cinematic film.
              </p>
              <p>
                7.2.2 - After receiving a draft cinematic video, the client
                needs to provide feedback for modifications or confirmation for
                final delivery within seven days from the date of receiving the
                draft cinematic video.
              </p>
              <p>
                7.2.3 - We are providing only a one-time rework facility in
                cinematic film processing. Hence feedback on draft cinematic
                video modifications is to be shared carefully.
              </p>
              <p>
                7.2.4 - Extra basic charges will be applicable in case of a
                third time or any further modification requirement shared in the
                draft cinematic video.
              </p>
              <p>
                7.2.5 - In case of no feedback is received on the draft
                cinematic video within seven days, the shared draft cinematic
                video will be considered for processing the final delivery of
                the cinematic film.
              </p>
              <p>
                7.2.6 - Further deliveries will be delayed in case of a delayed
                response from the client.
              </p>
              <p>
                7.2.7 - Once final delivery is confirmed and completed, no extra
                requirements will be served without payment.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>8. DIGITAL FILE QUALITY</h3>
              <p>
                8.1 - A photographer is committed to providing high-quality
                services. Unless otherwise specified, Photographer may deliver,
                and Client agrees to accept, the image(s) encoded in an
                industry-standard data format that Photographer may select, at a
                resolution that Photographer determines will be suitable to the
                subject matter of the Image(s) and the reproduction technology
                and use(s) for which the Image(s) is licensed.
              </p>
              <p>
                8.2 - Due to variances in monitor calibrations, software, and
                computer platforms, digital files may display differently on
                different monitors. Therefore, neutrals will be set for
                mathematical neutrality and color will be adjusted for pleasing
                tonalities.
              </p>
              <p>
                8.3 - It is the Client's responsibility to verify that the
                digital data, including color profile, if provided, are suitable
                for reproduction of the expected quality and color accuracy, and
                that all necessary steps are taken to ensure correct
                reproduction. If the data are not deemed suitable,
                Photographer’s sole obligation will be to replace or repair the
                data, but in no event will Photographer be liable for poor
                reproduction quality, delays, losses, expenses, or consequential
                damages, resulting directly, or indirectly, from defects or
                errors in digital files or their use.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>9. ACCEPTANCE OF TERMS</h3>
              <p>
                9.1 - A client may not assign or transfer this Agreement or any
                rights granted under it. This agreement binds Client and inures
                to the benefit of Photographer, as well as their respective
                principals, employees, agents, affiliates, heirs, legal
                representatives, successors, and assigns. Client and its
                principals, employees, agents, and affiliates, are jointly and
                severally liable for the performance of all payments and other
                obligations hereunder.
              </p>
              <p>
                9.2 - No amendment or waiver of any items is binding unless set
                forth in writing and signed by the parties. E-mail and
                electronic signatures will be considered legal and binding.
                However, the invoice may reflect, and Client is bound by,
                Client’s oral authorizations for any additional image(s), fees,
                and expenses, that could not be confirmed in writing due to the
                immediate proximity of completing the assignment.
              </p>
              <p>
                9.3 - If any provision of this agreement shall be unlawful,
                void, or for any reason is unenforceable, then that provision
                shall be deemed severable from this agreement and shall not
                affect the validity and enforceability of any remaining
                provisions.
              </p>
              <p>
                9.4 - In addition to written agreements, the use of any image(s)
                by the Cconcerningperiodlient will constitute acceptance of all
                the above terms and conditions.
              </p>
            </div>
            <br />
            <div class="content_tc">
              <h3>10. PRIVACY POLICY</h3>
              <p>
                10.1 - Your use of the Website is also subject to the Company’s
                Privacy Policy. Please review our{" "}
                <a href="/privacyPolicy">Privacy Policy.</a>
              </p>
            </div>
            <br />
            {/* <div class="social">
              <a href="https://www.facebook.com/fodrix">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/fodrixx">
                <i class="fab fa-twitter"></i>
              </a>
              <a href="https://www.instagram.com/fodrixx/">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/fodrix/">
                <i class="fab fa-linkedin"></i>
              </a>
              <a href="https://www.youtube.com/watch?v=gvWu9sw-iK4">
                <i class="fab fa-youtube"></i>
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
